<template>
    <div v-if="isLastStand" class="LSContainer noselect">
        <h2>Last Stand</h2>
    </div>
</template>

<script>

export default {
    name: "LastStand",
    props: {
        isLastStand:Boolean
    },
    data() {
        return {
            burnAway: true
        }
    },
    methods:{
        burnCard(){
            this.burnAway = true;
            setTimeout(() => this.burnAway = false, 2000)
        }
    }
    
}
</script>

<style scoped>

    .LSContainer {
                z-index: 4;

    }
    h2 {
        font-family: "Eordeoghlakat", sans-serif;
        font-size: 8.25em;
        margin-top: -200px;
        color:maroon;
        filter:drop-shadow(0px 0px 10px maroon);
        animation: candle-flicker 2s ease infinite, shake 1s linear infinite;
    }

    @keyframes shake {
         10%, 85%  {
    transform: translate3d(-1px, 1px, 0);
    }
    15%, 55%, 80%, 65%, 90% {
        transform: translate3d(0px, 0, 0);
    }
    60%,70%, 95%  {
        transform: translate3d(1px, 1px, 0);
    }
    75%, 100% {
        transform: translate3d(-2px, 1px, 0);
    }
    }

</style>
